// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V22H22V2ZM12 8.5L16.25 14H7.75L12 8.5Z"}}]};

const ChevronUpRectangleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-up-rectangle-filled',
    ref,
    icon: element,
  },
));

ChevronUpRectangleFilledIcon.displayName = 'ChevronUpRectangleFilledIcon';

export default ChevronUpRectangleFilledIcon;
